import {view} from '@sail/ui';
import type {CssProperties} from '@sail/ui';

export type TextType =
  | 'mediumEmphasized'
  | 'body'
  | 'bodyEmphasized'
  | 'headline'
  | 'heading'
  | 'input'
  | 'caption'
  | 'captionEmphasized'
  | 'labelEmphasized'
  | 'title';

type TextStyle = {
  lineHeight: string;
  fontSize: string;
  weight: number;
  opacity?: number;
  letterSpacing?: string;
};

const TEXT_TYPE_SETTINGS: Record<TextType, TextStyle> = {
  mediumEmphasized: {
    lineHeight: '24px',
    fontSize: '16px',
    weight: 600,
    letterSpacing: '-0.31px',
  },
  bodyEmphasized: {
    lineHeight: '20px',
    fontSize: '14px',
    weight: 500,
    letterSpacing: '-0.15px',
  },
  body: {
    lineHeight: '20px',
    fontSize: '14px',
    weight: 400,
    letterSpacing: '-0.15px',
  },
  headline: {
    lineHeight: '32px',
    fontSize: '28px',
    weight: 600,
    letterSpacing: '0.39px',
  },
  heading: {
    lineHeight: '24px',
    fontSize: '16px',
    weight: 500,
    letterSpacing: '-0.32px',
  },
  input: {
    lineHeight: '16px',
    fontSize: '13px',
    weight: 500,
    letterSpacing: '-0.08px',
  },
  caption: {
    lineHeight: '16px',
    fontSize: '12px',
    weight: 400,
    letterSpacing: '0px',
  },
  captionEmphasized: {
    lineHeight: '16px',
    fontSize: '12px',
    weight: 500,
    letterSpacing: '0px',
  },
  labelEmphasized: {
    lineHeight: '20px',
    fontSize: '14px',
    weight: 600,
    letterSpacing: '-0.15px',
  },
  title: {
    lineHeight: '28px',
    fontSize: '20px',
    weight: 500,
    letterSpacing: '-0.46px',
  },
};

export const Text = ({
  type,
  children,
  css: cssOverrides,
}: {
  type: TextType;
  children: React.ReactNode;
  css?: CssProperties;
}) => {
  const selectedType = TEXT_TYPE_SETTINGS[type];

  return (
    <view.span
      css={{
        margin: 'space.0',
        maxWidth: 'fit',
        lineHeight: selectedType.lineHeight,
        fontSize: selectedType.fontSize,
        fontWeight: selectedType.weight,
        color: 'text',
        ...cssOverrides,
      }}
    >
      {children}
    </view.span>
  );
};
